<template>
  <div class="kcgl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factoryid" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="130"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderType===0">正单</span>
                      <span v-if="scope.row.orderType===1">客改单</span>
                      <span v-if="scope.row.orderType===2">增补单</span>
                      <span v-if="scope.row.orderType===3">色板单</span>
                      <span v-if="scope.row.orderType===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="剩余库存包数"
                    width="150"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#F56C6C;">{{scope.row.inpacknum-scope.row.outednum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最后入库时间"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.itime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="所在车间"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factory}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="openDetails(scope.row)" icon="el-icon-document">库存详细</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editForm.xuhao" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button :loading="printLoading" icon="el-icon-printer" @click="printFhqd">打印发货清单</el-button>
          <el-button icon="el-icon-printer" :loading="exportMaterialLoading" plain @click="exportExcelMaterial">导出Excel</el-button>
        </el-form-item>
      </el-form>
      <div style="padding-bottom: 20px" v-loading="packloading">
        <el-table
          ref="packTable"
          :data="packTableData"
          :row-style="{cursor: 'pointer'}"
          @row-click="openPackDetails"
          class="tcf-expand"
          min-height="400"
          @selection-change="handleSelectionChange"
          size="small">
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="tcf-panel">
                <p class="tcf-panel-header">
                  <span style="color:#99a9bf"><i class="el-icon-box"></i> 包装 {{props.row.packnum}} 部件详细</span>
                </p>
                <div class="tcf-panel-body">
                  <el-table
                    :data="props.row.materialdataList"
                    size="mini"
                    :show-header="false"
                    style="width: 100%">
                    <el-table-column prop="barCode" fixed label="条码" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="xuhao" fixed label="序号" show-overflow-tooltip width="70"></el-table-column>
                    <el-table-column prop="area" label="区域" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="type" label="分类" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column prop="name" label="名称" show-overflow-tooltip width="130"></el-table-column>
                    <el-table-column prop="material" label="基材" show-overflow-tooltip width="80"></el-table-column>
                    <el-table-column label="规格" show-overflow-tooltip width="140">
                      <template slot-scope="scope">
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                        <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                        <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                        <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" show-overflow-tooltip min-width="130"></el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="packnum" align="center" label="包标签号" show-overflow-tooltip width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="90"></el-table-column>
          <el-table-column prop="iusername" align="center" label="入库人" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="itime" align="center" label="入库时间" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="num" align="center" label="部件数量" show-overflow-tooltip width="90"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getErpInStockList,
  getErpOrderPackList,
  printShippingList,
  getFactoryList,
  exportStockControlList,
  exportShippingList, getGroupInfoByUser
} from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'kcgl',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportMaterialLoading: false,
      exportLoading: false,
      searchForm: {
        search: '',
        factoryid: null,
        orderType: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editTitle: '',
      editVisible: false,
      editLoading: false,
      editForm: {
        orderid: '',
        packnum: '',
        xuhao: ''
      },
      packTableData: [],
      packloading: false,
      multipleSelection: [],
      printLoading: false,
      factoryList: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    this.getData()
  },
  methods: {
    exportExcelMaterial() {
      if (this.multipleSelection.length > 0) {
        if (!this.exportMaterialLoading) {
          this.exportMaterialLoading = true
          let packids = []
          for (let p of this.multipleSelection) {
            packids.push(p.packid)
          }
          const data = {
            orderid: this.editForm.orderid,
            packids: packids.join(',')
          }
          exportShippingList(data).then(response => {
            this.exportMaterialLoading = false
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.file_url, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a',
                      { attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }}, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {
                })
              }
            }
            xhr.send()
          }).catch(() => {
            this.exportMaterialLoading = false
          })
        }
      } else {
        this.$message.error('至少选择一个包装进行导出')
      }
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          factoryid: this.searchForm.factoryid,
          orderType: this.searchForm.orderType,
          tableName: '库存管理'
        }
        exportStockControlList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        factoryid: this.searchForm.factoryid,
        orderType: this.searchForm.orderType
      }
      getErpInStockList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (row.bid === 3) {
        this.editTitle = row.ordernum + ' 库存详细'
      } else {
        this.editTitle = row.produnum + ' 库存详细'
      }
      this.editForm.orderid = row.orderid
      this.editForm.packnum = ''
      this.editForm.xuhao = ''
      this.editVisible = true
      this.searchPack()
    },
    searchPack() {
      this.packTableData = []
      this.packloading = true
      const data = {
        orderid: this.editForm.orderid,
        packnum: this.editForm.packnum,
        xuhao: this.editForm.xuhao,
        imark: 1,
        isall: 1,
        iskc: 1
      }
      getErpOrderPackList(data).then(response => {
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    openPackDetails(row) {
      this.$refs.packTable.toggleRowExpansion(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    printFhqd() {
      if (this.multipleSelection.length > 0) {
        if (!this.printLoading) {
          const LODOP = getLodop()
          if (LODOP !== null && LODOP !== undefined) {
            this.printLoading = true
            let packids = []
            for (let p of this.multipleSelection) {
              packids.push(p.packid)
            }
            const data = {
              orderid: this.editForm.orderid,
              packids: packids.join(',')
            }
            printShippingList(data).then(response => {
              LODOP.PRINT_INIT('出库清单打印')
              LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
              LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
              LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
              LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
              LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
              LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
              LODOP.NewPageA()
              LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
              LODOP.PREVIEW()
              this.printLoading = false
            }).catch(() => {
              this.printLoading = false
            })
          }
        }
      } else {
        this.$message.error('至少选择一个包装进行打印')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.kcgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
